import PropTypes from "prop-types";
import React from "react";
import SVG from "theme/components/icons/base/SVG";
import styled from "theme/libs/styled";

const directions = {
    down: "90deg",
    left: "180deg",
    up: "270deg",
    right: "0",
};

const StyledSVG = styled(SVG)`
    transform: rotate(${({ rotate }) => rotate});
`;

const ArrowIcon = ({ color, width, height, viewBox, direction, ...rest }) => (
    <StyledSVG
        width={width}
        height={height}
        viewBox={viewBox}
        rotate={directions[direction]}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m4.82.24 6.5 5.5.45.38-.45.38-6.5 5.5-.64-.76 5.46-4.62H0v-1h9.64L4.18 1l.64-.76Z"
            fill={color}
        />
    </StyledSVG>
);

ArrowIcon.propTypes = {
    color: PropTypes.string,
    direction: PropTypes.oneOf(["left", "right", "up", "down"]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

ArrowIcon.defaultProps = {
    color: "currentColor",
    direction: "right",
    height: "12px",
    viewBox: "0 0 12 12",
    width: "12px",
};

export default ArrowIcon;
